// Main js file for the object
function search() {
  console.log('search');
}

export default search;
